import internal from "stream";
import { IBrand } from "./IBrand";
import { IGCPBigQueryJob, IPolygon, IProfileRecord } from "./Models";

export interface IGPSData {
  actualConsumerViewRollups: IPrimarySecondaryConsumerViewRollups;
  estimatedVolume: IEstimatedVolumeCount;
  buds: number;
  region: string;
  visitsCount: number;
  mapData: IMobileInsightsMapData[];
  nationalConsumerViewRollups: IGenericConsumerViewRollups;
  profile: IGPSProfile[];
  visitorOrigination: IChartVisitorOrigData;
  tradeAreaAnalysis: IChartTAAData[];
  volumeByDOW: IChartVisitVisitorDatapoint[];
  volumeByHour: IChartGenericDatapoint[];
  volumeBySegment: IChartVisitVisitorDatapoint[];
  volumeByWeek: IChartVisitVisitorDatapoint[];
  volumeByDay: IChartVisitVisitorDatapoint[];
  frequentlyVisitedPlaces: IFrequentlyVisitedPlace[];
}

export interface IFrequentlyVisitedPlace {
  address: string;
  afterDevCount: number;
  afterVisitCount: number;
  beforeDevCount: number;
  beforeVisitCount: number;
  brand: IBrand | null;
  categoryId: string;
  city: string;
  devCount: number;
  jobId: string;
  latitude: number;
  longitude: number;
  name: string;
  source: string;
  state: string;
  storeId: string;
  visitCount: number;
  zipcode: string;
  percentage: number;
}
export interface IGPSProfile {
  actualCount: number;
  actualPercent: number;
  baseCount: number;
  basePercent: number;
  core: "P" | "S" | "N" | "T";
  index: number;
  segment: string;
}

export interface IEstimatedVolumeCount {
  visitors: number;
  visits: number;
  visitsCount: number;
}

export interface IChartGenericDatapoint {
  id: string;
  weight: number;
}

export interface IGPSIndexDatapoint {
  id: string;
  indexValue: number;
}

export interface IChartVisitVisitorDatapoint {
  id: string;
  visitWeight: number;
  visitorWeight: number;
}

export interface IGPSChartMergedDatapoint {
  id: string;
  visitWeight?: number;
  visitorWeight?: number;
  weight?: number;
}

export interface IChartMergedDatapoint {
  id: string;
  selection1PrimaryWeight?: number;
  selection1SecondaryWeight?: number;
  selection2PrimaryWeight?: number;
  selection2SecondaryWeight?: number;
  nationalWeight?: number;
}

export interface IPrimarySecondaryConsumerViewRollups {
  childrenPresent: IChartVisitVisitorDatapoint[];
  dwellingType: IChartVisitVisitorDatapoint[];
  hhIncome: IChartVisitVisitorDatapoint[];
  hohAge: IChartVisitVisitorDatapoint[];
  hohEducationLevel: IChartVisitVisitorDatapoint[];
  homeOwnership: IChartVisitVisitorDatapoint[];
  lengthOfResidence: IChartVisitVisitorDatapoint[];
  maritalStatus: IChartVisitVisitorDatapoint[];
  newHomeOwner: IChartVisitVisitorDatapoint[];
  newMover: IChartVisitVisitorDatapoint[];
  numPersonsInHh: IChartVisitVisitorDatapoint[];
  hohEthnicGroup: IChartVisitVisitorDatapoint[];
}

export interface IGenericConsumerViewRollups {
  childrenPresent: IChartGenericDatapoint[];
  dwellingType: IChartGenericDatapoint[];
  hhIncome: IChartGenericDatapoint[];
  hohAge: IChartGenericDatapoint[];
  hohEducationLevel: IChartGenericDatapoint[];
  homeOwnership: IChartGenericDatapoint[];
  lengthOfResidence: IChartGenericDatapoint[];
  maritalStatus: IChartGenericDatapoint[];
  newHomeOwner: IChartGenericDatapoint[];
  newMover: IChartGenericDatapoint[];
  numPersonsInHh: IChartGenericDatapoint[];
  hohEthnicGroup: IChartGenericDatapoint[];
}

export interface IChartCompare {
  selection1:
    | IChartVisitVisitorDatapoint[]
    | IChartGenericDatapoint[]
    | IProfileRecord[]
    | IGPSProfile[]
    | IChartVisitorOrigData;
  selection2?:
    | IChartVisitVisitorDatapoint[]
    | IChartGenericDatapoint[]
    | IProfileRecord[]
    | IGPSProfile[]
    | IChartVisitorOrigData;
  national: IChartGenericDatapoint[];
}

export interface IMobileInsightsMapData {
  homeLatitude: number;
  homeLongitude: number;
  visitWeight: number;
  visitorWeight: number;
  workLatitude: number;
  workLongitude: number;
}

export interface IGPSGetJobResult {
  job: IGCPBigQueryJob[];
  chartData: IGPSData[];
  status: string;
  benchmarkCommonData: IGPSBenchmarkCommonData;
}

export interface IGPSVisitorLoyalty {
  jobIds: string[];
  value: number;
}

export interface IGPSBenchmarkCommonData {
  visitorLoyalty: IGPSVisitorLoyalty[];
}

export interface IGPSGetJobResultParsed {
  polygon: IPolygon[];
  data: IGPSData[];
  job: IGCPBigQueryJob[];
  benchmarkCommonData: IGPSBenchmarkCommonData;
}

export interface IGPSAMChartData {
  week: IChartVisitVisitorDatapoint[];
  dow: IChartVisitVisitorDatapoint[];
  hour: IChartGenericDatapoint[];
}

export interface IChartCalendarDatapoint {
  day: string;
  value: number;
}

export interface IChartVisitorOrigData {
  county: IGPSChartMergedDatapoint[];
  dma: IGPSChartMergedDatapoint[];
  state: IGPSChartMergedDatapoint[];
  zipcode: IGPSChartMergedDatapoint[];
}

export interface IChartVisitorOrigData {
  county: IGPSChartMergedDatapoint[];
  dma: IGPSChartMergedDatapoint[];
  state: IGPSChartMergedDatapoint[];
  zipcode: IGPSChartMergedDatapoint[];
}

export interface IChartTAAData {
  id: string;
  visitWeight: string;
  visitorWeight: string;
}
